/**
 * useRouteDocumentTitle — Mirrors the AngularJS $routeChangeSuccess handler
 * that sets `$rootScope.G_PAGE_TITLE = $route.current.$$route.title` and the
 * `<title>{{G_PAGE_TITLE}} - SafeView</title>` binding from
 * `public/index.html`.
 *
 * Listens to React Router location changes, looks up the matching title in
 * the AngularJS route table (`ROUTE_TITLES`), and writes
 * `document.title = '{title} - SafeView'`. When a route has no title entry
 * (matches AngularJS routes without a `title:` field), document.title falls
 * back to the bare app name.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveRouteTitle } from '@/routes/routeTitles';

const APP_NAME = 'SafeView';

export function useRouteDocumentTitle(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    const title = resolveRouteTitle(pathname);
    document.title = title ? `${title} - ${APP_NAME}` : APP_NAME;
  }, [pathname]);
}
